import React from 'react';
import { Link } from 'react-router-dom';
import LegalPageLayout from '../components/LegalPageLayout';

const SITEMAP_SECTIONS = [
  {
    title: 'Main',
    links: [
      { to: '/', label: 'Home' },
      { to: '/search', label: 'Search Stays' },
      { to: '/properties', label: 'Browse Properties' },
      { to: '/offers-deals', label: 'Offers & Deals' },
      { to: '/ai-assistant', label: 'AI Stay Finder' },
    ],
  },
  {
    title: 'Bookings & Account',
    links: [
      { to: '/login', label: 'Sign In' },
      { to: '/trips', label: 'My Bookings' },
      { to: '/wishlist', label: 'Saved Stays' },
      { to: '/notifications', label: 'Notifications' },
      { to: '/account', label: 'Profile Settings' },
      { to: '/my-payments', label: 'Payment History' },
      { to: '/refund-status', label: 'Refund Status' },
    ],
  },
  {
    title: 'Meeting Rooms',
    links: [
      { to: '/meeting-home', label: 'Meeting Home' },
      { to: '/meetings/book', label: 'Book Meeting Room' },
      { to: '/meetings/my-bookings', label: 'My Meeting Bookings' },
      { to: '/meetings/schedule', label: 'Schedule' },
      { to: '/meetings/workspace', label: 'Private Workspace' },
      { to: '/meetings/create-team', label: 'Create Your Team' },
      { to: '/meetings/favourite', label: 'Favourite Rooms' },
    ],
  },
  {
    title: 'Host',
    links: [
      { to: '/host', label: 'Host Dashboard' },
      { to: '/host/add-property', label: 'Add New Property' },
      { to: '/host/messages', label: 'Host Messages' },
    ],
  },
  {
    title: 'Help & Legal',
    links: [
      { to: '/help', label: 'Help Centre' },
      { to: '/faq', label: 'FAQ' },
      { to: '/feedback', label: 'Feedback' },
      { to: '/privacy', label: 'Privacy Policy' },
      { to: '/terms', label: 'Terms of Service' },
      { to: '/cookies', label: 'Cookie Policy' },
      { to: '/sitemap', label: 'Sitemap' },
    ],
  },
];

const SitemapPage = () => (
  <LegalPageLayout title="Sitemap" lastUpdated="July 14, 2026">
    <p>
      Use this sitemap to find key pages on <strong>UBSAAPP</strong>. Some pages require you to be
      signed in (for example, bookings, account settings, and host tools).
    </p>

    <div className="sitemap-sections">
      {SITEMAP_SECTIONS.map((section) => (
        <section key={section.title} className="sitemap-section">
          <h2>{section.title}</h2>
          <ul className="sitemap-links">
            {section.links.map((link) => (
              <li key={link.to}>
                <Link to={link.to}>{link.label}</Link>
              </li>
            ))}
          </ul>
        </section>
      ))}
    </div>
  </LegalPageLayout>
);

export default SitemapPage;
